import { render, staticRenderFns } from "./DetailItem.vue?vue&type=template&id=15bd4a02"
import script from "./DetailItem.vue?vue&type=script&lang=ts"
export * from "./DetailItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports